import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import type { ISPD } from '../../sprites/sprites'
import { sprites } from '../../sprites/sprites-sidecar'
import { voyageColors } from './voyageColors-sidecar'

export enum EVoyageTile {
  Default = -1,
  Null2 = 0,
  SquareBottom = 1,
  CheckerBottom = 2,
  Square = 3,
  Triangle = 4,
  Checker = 5,
  Floor = 6,
  ShadeBottom = 7,
  Door = 8,
  Fence = 9,
  FakeBottom = 10,
  Chair = 11,
  Table = 12,
  Null3 = 100,
  Text = 101,
  CrewSpawn = 102,
  System = 103,
  Elevator = 104,
  Test = 105,
  MedPad = 106,
}

export interface IVoyageTileData {
  type: EVoyageTile
  layer: number
  frames: ISPD[]
  canWalk: boolean
  colors: number[]
  includesText: boolean
  isNull: boolean
  pathfindPenalty: number
}

const _default: IVoyageTileData = {
  type: EVoyageTile.Default,
  layer: 2,
  frames: sprites.voyTileCheckerFine1,
  canWalk: false,
  colors: voyageColors.all,
  includesText: false,
  isNull: false,
  pathfindPenalty: 0,
}

export const dataList: IVoyageTileData[] = []
export const dataMap: IVoyageTileData[] = []
const dataType = 'voyage-tiles'
export const get = (type: number) => {
  return entitiesUtils.genericGetDataNum(dataType, dataMap, type)
}
export const register = (data: Partial<IVoyageTileData>) => {
  entitiesUtils.genericRegisterDataNum(
    dataType,
    data,
    _default,
    dataList,
    dataMap,
  )
}

export const layer1: IVoyageTileData[] = []
export const layer2: IVoyageTileData[] = []
export const layer3: IVoyageTileData[] = []

export function registerAll() {
  register({
    type: EVoyageTile.SquareBottom,
    frames: sprites.voyTileSquareBottom,
    layer: 1,
    colors: [voyageColors.g1],
    isNull: true,
  })
  register({
    type: EVoyageTile.CheckerBottom,
    frames: sprites.voyTileChecker1,
    layer: 1,
    colors: [voyageColors.g2],
    //    isNull: true,
  })

  register({
    type: EVoyageTile.FakeBottom,
    frames: sprites.voyTileSquare,
    layer: 1,
    colors: [voyageColors.g1],
    //    isNull: true,
  })

  register({
    type: EVoyageTile.ShadeBottom,
    frames: [
      ...sprites.voyTileTri1,
      ...sprites.voyTileTri2,
      ...sprites.voyTileTri3,
      ...sprites.voyTileTri4,
    ],
    colors: [voyageColors.g2],
    layer: 1,
  })

  register({
    type: EVoyageTile.Null2,
    frames: sprites.voyTileNull,
    isNull: true,
  })

  register({
    type: EVoyageTile.Square,
    frames: sprites.voyTileSquare,
    colors: [
      voyageColors.g2,
      voyageColors.g3,
      voyageColors.g4,
      voyageColors.purple,
    ],
  })
  register({
    type: EVoyageTile.Floor,
    frames: sprites.voyTileSquare,
    colors: [voyageColors.g1],
    canWalk: true,
  })

  register({
    type: EVoyageTile.Door,
    frames: sprites.voyTileFence1,
    colors: [voyageColors.g4],
    canWalk: true,
  })

  register({
    type: EVoyageTile.Chair,
    frames: sprites.voyTileChair,
    colors: [voyageColors.g3],
    canWalk: true,
  })
  register({
    type: EVoyageTile.Table,
    frames: sprites.voyTileTable,
    colors: [voyageColors.g3],
  })

  register({
    type: EVoyageTile.Triangle,
    frames: [
      ...sprites.voyTileTri1,
      ...sprites.voyTileTri2,
      ...sprites.voyTileTri4,
      ...sprites.voyTileTri3,
    ],
  })

  register({
    type: EVoyageTile.Fence,
    frames: [
      ...sprites.voyTileFence1,
      ...sprites.voyTileFence2,
      ...sprites.voyTileFence3,
    ],

    colors: [voyageColors.g2, voyageColors.g3],
  })

  register({
    type: EVoyageTile.Null3,
    frames: sprites.voyTileNull,
    layer: 3,
    isNull: true,
  })
  register({
    type: EVoyageTile.Text,
    frames: sprites.voyTileSpecialT,
    layer: 3,
    colors: [voyageColors.purple],
    includesText: true,
  })
  register({
    type: EVoyageTile.CrewSpawn,
    frames: sprites.voyTileSpecialC,
    layer: 3,
    colors: [voyageColors.purple],
  })
  register({
    type: EVoyageTile.System,
    frames: sprites.voyTileStation,
    layer: 3,
    colors: [voyageColors.purple],
    includesText: true,
    pathfindPenalty: 4,
  })
  register({
    type: EVoyageTile.Elevator,
    frames: sprites.voyTileSpecialE,
    layer: 3,
    colors: [voyageColors.purple],
    includesText: true,
    pathfindPenalty: 5,
  })
  register({
    type: EVoyageTile.MedPad,
    frames: [sprites.voyTilePluses[1]],
    layer: 3,
    colors: [voyageColors.purple],
    includesText: true,
  })
  register({
    type: EVoyageTile.Test,
    frames: sprites.voyTileSpecialTest,
    layer: 3,
    colors: [voyageColors.purple],
    includesText: true,
  })
  layer1.push(...l.filter(dataList, (c) => c.layer === 1))
  Object.freeze(layer1)
  layer2.push(...l.filter(dataList, (c) => c.layer === 2))
  Object.freeze(layer2)
  layer3.push(...l.filter(dataList, (c) => c.layer === 3))
  Object.freeze(layer3)
}
